import { render } from "./information-box.vue?vue&type=template&id=3cb9270a"
import script from "./information-box.vue?vue&type=script&lang=js"
export * from "./information-box.vue?vue&type=script&lang=js"

import "./information-box.vue?vue&type=style&index=0&id=3cb9270a&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__